import type { Rule } from 'antd/es/form';

// 密码复杂度规则（与后端 PasswordPolicy 保持一致）：
// 长度 8-16；必须同时包含 英文字母（不分大小写）、数字、特殊字符 三类；且只允许这三类字符。
export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 16;

// 允许的特殊字符集合（与后端 PasswordPolicy.SPECIAL_CHARS 一致）
const SPECIAL_CHARS = "!@#$%^&*()-_=+[]{};:'\",.<>/?\\|`~";

export const isValidPassword = (password: string | null | undefined): boolean => {
  if (!password) return false;
  if (password.length < PASSWORD_MIN_LENGTH || password.length > PASSWORD_MAX_LENGTH) return false;

  let hasLetter = false;
  let hasDigit = false;
  let hasSpecial = false;
  for (const c of password) {
    if ((c >= 'a' && c <= 'z') || (c >= 'A' && c <= 'Z')) {
      hasLetter = true;
    } else if (c >= '0' && c <= '9') {
      hasDigit = true;
    } else if (SPECIAL_CHARS.includes(c)) {
      hasSpecial = true;
    } else {
      // 含不允许的字符（空格、unicode 等）
      return false;
    }
  }
  return hasLetter && hasDigit && hasSpecial;
};

// Ant Design Form 校验规则工厂。
// 空值放过（由各表单的 required 规则单独处理：新建必填、编辑可留空表示不改）。
export const passwordPolicyRule = (message: string): Rule => ({
  validator: (_rule, value: string) =>
    !value || isValidPassword(value)
      ? Promise.resolve()
      : Promise.reject(new Error(message)),
});
